import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useSmartBack } from '../hooks/useSmartBack';

/**
 * Bouton retour intelligent — contextuel, accessible, premium.
 * S'adapte automatiquement au thème (dark / light via .theme-light).
 *
 * Props :
 *   - to (string)        : force une destination explicite (désactive useSmartBack)
 *   - label (string)     : force le libellé (override useSmartBack label)
 *   - className (string) : classes additionnelles
 *   - variant (string)   : 'light' applique des couleurs adaptées aux fonds sombres
 *   - data-testid        : permet de granulariser le ciblage E2E
 */
export default function BackButton({
  className = '',
  to,
  label,
  variant,
  'data-testid': testid = 'smart-back-button',
}) {
  const getBackInfo = useSmartBack();
  const navigate = useNavigate();
  const info = getBackInfo();

  const finalAction = to ? () => navigate(to) : info.action;
  const finalLabel = label || (to && !label ? 'Retour' : info.label);

  // Iter294 — variant 'light' : surface adaptée aux hero sombres (Pulse Team Hero)
  const baseClass = variant === 'light'
    ? 'group flex items-center gap-2 py-2.5 pr-4 -ml-1 text-white/70 hover:text-white active:text-[#F3D060] transition-all'
    : 'back-btn group flex items-center gap-2 py-2.5 pr-4 -ml-1 text-zinc-400 hover:text-white active:text-[#D4AF37] transition-all';
  const iconClass = variant === 'light'
    ? 'w-8 h-8 rounded-lg bg-white/10 group-hover:bg-white/20 group-active:bg-[#F3D060]/20 flex items-center justify-center transition-all'
    : 'back-btn-icon w-8 h-8 rounded-lg bg-white/5 group-hover:bg-white/10 group-active:bg-[#D4AF37]/10 flex items-center justify-center transition-all';

  return (
    <button
      data-testid={testid}
      onClick={finalAction}
      className={`${baseClass} ${className}`}
    >
      <span className={iconClass}>
        <ArrowLeft className="w-4 h-4" />
      </span>
      <span className="text-sm font-medium">{finalLabel}</span>
    </button>
  );
}
